import { useMemo } from "react";

import { useSelector } from "react-redux";

import {
  getObjLength,
  isMonitoringTierCustomer,
  normalizeSubscriptionCategory,
  resolveCustomerProfileCategory,
} from "../helpers/utils";
import useBasicPlanOnlyCustomer from "./useBasicPlanOnlyCustomer";

export function useCompleteProtectionCustomer() {
  const { subscriptionsLoaded, subscriptionLoader } = useBasicPlanOnlyCustomer();
  const { subscriptionData } = useSelector(
    (state: any) => state?.subscription || {},
  );
  const { userProfileDetails } = useSelector(
    (state: any) => state?.userProfile || {},
  );
  const { propertiesData } = useSelector(
    (state: any) => state?.properties || {},
  );

  const profileCategory = resolveCustomerProfileCategory({
    profileCategory: userProfileDetails?.data?.category,
    profileProductTier: userProfileDetails?.data?.product_tier,
    propertiesData,
  });

  const subscriptions =
    subscriptionData?.success && Array.isArray(subscriptionData?.data)
      ? subscriptionData.data
      : [];

  const isMonitoringTier = isMonitoringTierCustomer({
    subscriptions,
    profileCategory,
    subscriptionsLoaded,
  });

  const hasCompleteProtection =
    profileCategory === "complete_protection" ||
    (subscriptionsLoaded && !isMonitoringTier);

  const completeProtectionProperties = useMemo(() => {
    if (!Array.isArray(subscriptions)) {
      return [];
    }

    return subscriptions.filter((item) => {
      const category = normalizeSubscriptionCategory(item);
      const fromRiskMeasure = Boolean(item?.from_risk_measure);
      return category === "complete_protection" && !fromRiskMeasure;
    });
  }, [subscriptions]);

  return {
    hasCompleteProtection,
    isMonitoringTier,
    subscriptionsLoaded,
    subscriptionLoader: subscriptionLoader && !subscriptionsLoaded,
    completeProtectionProperties,
    profileLoaded: getObjLength(userProfileDetails) > 0 || subscriptionsLoaded,
  };
}

export default useCompleteProtectionCustomer;
